module.exports = __webpack_public_path__ + "static/media/metamask_icon.023762b6.png";